import React, {useEffect, useRef, useState} from 'react';
import axios from '../../services/axiosInstance';

import maCateImg from "../../assets/img/m-a-cate.png";
import AdminYmdEvent from "../../components/web/layoutsadmin/AdminYmdEvent";

function AdminProfitCalcuPg() {

    const SSAT = sessionStorage.getItem('adminToken');
    const LCAT = localStorage.getItem('adminToken');

    const [adminInfo, setAdminInfo] = useState([]);

    const selectAdminInfo = (() => {
        axios({
            method: 'get',
            url: '/member/modiInfo',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response)=> {
                setAdminInfo(response.data[0])
            })
            .catch(()=> {
                console.log("멤버조회 실패")
            })
    })

    useEffect(() => {
        selectAdminInfo();
    }, [])

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    useEffect(() => {
        const date = new Date();
        // ✅ 오늘 날짜에서 1을 빼서 '어제'로 설정
        date.setDate(date.getDate() - 1);

        const fmt = d => {
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${y}-${m}-${day}`;
        };

        const yesterday = fmt(date);
        setStartDate(yesterday);
        setEndDate(yesterday);
    }, []);

    // ✅ endDate 변경 시마다: 해당 날짜 기준으로 startDate 재설정
    useEffect(() => {
        if (startDate && endDate) {
            selectedProfitCalcu();
        }
    }, [startDate, endDate]);

    const startHandle = (e) => {
        setStartDate(e.target.value);
    };

    const endHandle = (e) => {
        setEndDate(e.target.value);
    };

    const [postOfficeTotalSales, setPostOfficeTotalSales] = useState(0); // 우체국 총매출

    const [fedexProfit, setFedexProfit] = useState(0);
    const [fedexEcoProfit, setFedexEcoProfit] = useState(0);
    const [upsProfit, setUpsProfit] = useState(0);
    const [upsEcoProfit, setUpsEcoProfit] = useState(0);
    const [emsProfit, setEmsProfit] = useState(0);
    const [emsPreProfit, setEmsPreProfit] = useState(0);
    const [kPackProfit, setKPackProfit] = useState(0);
    const [sAirProfit, setSAirProfit] = useState(0);
    const [seaProfit, setSeaProfit] = useState(0);
    const [domeProfit, setDomeProfit] = useState(0);

    const [totalDeliveryFee, setTotalDeliveryFee] = useState(0); // 배송비 총합
    const [totalEtcFee, setTotalEtcFee] = useState(0);           // 기타비용(PT2) 총합

    const [orderVatProfit, setOrderVatProfit] = useState('');
    const [orderSaleProfit, setOrderSaleProfit] = useState('');
    const [transferProfit, setTransferProfit] = useState('');
    const [cardCashbag, setCardCashbag] = useState('');

    const [finalTotalAmount, setFinalTotalAmount] = useState(0); // 총 금액

    // 각 배송사별 데이터 건수
    const [fedexCount, setFedexCount] = useState(0);
    const [fedexEcoCount, setFedexEcoCount] = useState(0);
    const [upsCount, setUpsCount] = useState(0);
    const [upsEcoCount, setUpsEcoCount] = useState(0);
    const [emsCount, setEmsCount] = useState(0);
    const [emsPreCount, setEmsPreCount] = useState(0);
    const [kPackCount, setKPackCount] = useState(0);
    const [sAirCount, setSAirCount] = useState(0);
    const [seaCount, setSeaCount] = useState(0);
    const [domeCount, setDomeCount] = useState(0);

    const [isBtLoading, setIsBtLoading] = useState(false);
    const [btDisabled, setBtDisabled] = useState(false);

    const formatNumber = (value) => {
        const onlyNumber = value.replace(/[^0-9]/g, ''); // 숫자 이외 제거
        if (!onlyNumber) return '';
        return Number(onlyNumber).toLocaleString(); // 세자리 콤마
    };

    const handleOrderVatProfit = (e) => {
        setOrderVatProfit(formatNumber(e.target.value));
    };

    const handleOrderSaleProfit = (e) => {
        setOrderSaleProfit(formatNumber(e.target.value));
    };

    const handleTransferProfit = (e) => {
        setTransferProfit(formatNumber(e.target.value));
    };

    const handleCardCashbagProfit = (e) => {
        setCardCashbag(formatNumber(e.target.value));
    };

    const formattedStartDate = startDate.replace(/-/g, '');
    const formattedEndDate = endDate.replace(/-/g, '');

    useEffect(() => {
        const manualVat = Number(orderVatProfit.replace(/,/g, '')) || 0; // 구매일지 상품부가세
        const manualSale = Number(orderSaleProfit.replace(/,/g, '')) || 0; // 구매일지 할인금액
        const manualTransfer = Number(transferProfit.replace(/,/g, '')) || 0; // 구매일지 이체대행수수료
        const manualCashbag = Number(cardCashbag.replace(/,/g, '')) || 0; // 구매일지 카드캐시백

        const total = totalDeliveryFee + totalEtcFee + manualVat + manualSale + manualTransfer + manualCashbag;
        setFinalTotalAmount(total);

    }, [totalDeliveryFee, totalEtcFee, orderVatProfit, orderSaleProfit, transferProfit, cardCashbag]);

    const selectedProfitCalcu = () => {
        setIsBtLoading(true);
        setBtDisabled(true);

        axios({
            method: 'get',
            url: '/order/selectedProfitData/',
            params: {
                startDate: formattedStartDate,
                endDate: formattedEndDate
            }
        })
            .then((response) => {
                const data = response.data || [];

                // 우체국 총매출(EMS 지출일지용)
                let tempPostOfficeSales = 0;

                // 해외배송료와 기타비용 분기
                const pt1Items = data.filter(item => item.payType === 'PT1');
                const pt2Items = data.filter(item => item.payType === 'PT2');

                console.log("출고된 해외배송료 : ", pt1Items)

                console.group("=========== [PT2] 기타수수료 상세 내역 ===========");
                if (pt2Items.length > 0) {
                    pt2Items.forEach((item, index) => {
                        console.log(
                            `[${index + 1}] 주문번호: ${item.orderdtVO?.orderNumber || 'N/A'} | ` +
                            `항목: ${item.itemNm || '기타'} | ` +
                            `금액(ttEtcFee): ${Number(item.ttEtcFee).toLocaleString()}원`
                        );
                    });
                } else {
                    console.log("조회된 기타수수료 내역이 없습니다.");
                }

                // 수익계산 - EMS & EMSP는 수금액(costPrice)의 20% 계산 / 나머지는 수금액(costPrice) - 청구액(salePrice) 계산
                const getStatsByType = (targetDvType, costKey) => {
                    const targets = pt1Items.filter(item => item.dvType === targetDvType);

                    const count = targets.length; // 건수
                    const profit = targets.reduce((acc, cur) => {
                        const salePrice = cur.shipInfoDTO?.shipPrice || 0; // 판매가(실청구액)
                        const costPrice = cur[costKey] || 0;               // 원가(고객수금액)

                        let itemProfit;

                        // EMS 수익 = costPrice(고객수금액) - emsAddFee 값의 20%
                        if (targetDvType === 'D02') {
                            const addFee = cur.emsAddFee || 0; // 추가 차감액
                            // (원가 - 추가비용) * 0.2
                            itemProfit = Math.floor((costPrice - addFee) * 0.2);
                            tempPostOfficeSales += costPrice;
                        }
                        // EMSP 수익 = costPrice(고객수금액)의 20%
                        else if (targetDvType === 'D15') {
                            // EMS-Pre는 기존 로직 유지 (필요시 D02와 동일하게 변경 가능)
                            itemProfit = Math.floor(costPrice * 0.2);
                            tempPostOfficeSales += costPrice;
                        }
                        // K-Packet 매출만 합산
                        else if (targetDvType === 'D13') {
                            tempPostOfficeSales += (costPrice - 3000);
                            itemProfit = costPrice - salePrice;
                        }
                        // 기타특송사 수익 = costPrice(고객수금액) - 각 배송사 cusPrepay - salePrice(실청구액)
                        else {
                            let deduction = 0; // cusPrepay

                            if (targetDvType === 'D01') {
                                // FedEx: costPrice - fedexCusPrepay - salePrice
                                deduction = cur.fedexCusPrepay || 0;
                            } else if (targetDvType === 'D16') {
                                // FedEx-Eco: costPrice - fedexEcoCusPrepay - salePrice
                                deduction = cur.fedexEcoCusPrepay || 0;
                            } else if (targetDvType === 'D11') {
                                // UPS: costPrice - upsCusPrepay - salePrice
                                deduction = cur.upsCusPrepay || 0;
                            } else if (targetDvType === 'D17') {
                                // UPS-Eco: costPrice - upsEcoCusPrepay - salePrice
                                deduction = cur.upsEcoCusPrepay || 0;
                            }

                            // 나머지(Sea, K-Pack, S-Air 등)는 deduction = 0이라 차감없이 그대로 costPrice(수금액) - salePrice(실청구액)
                            itemProfit = (costPrice - deduction) - salePrice;
                        }

                        return acc + itemProfit;
                    }, 0);

                    return { count, profit };
                };

                // ✅ 각 dvType별 건수 및 수익 추출
                const statsDome = getStatsByType('D00', 'ttDomPrice');
                const statsFedex = getStatsByType('D01', 'ttFedexPrice');
                const statsFedexEco = getStatsByType('D16', 'ttFedexEcoPrice');
                const statsEms = getStatsByType('D02', 'ttEmsPrice');
                const statsEmsPre = getStatsByType('D15', 'ttEmsPrePrice');
                const statsSea = getStatsByType('D03', 'ttSeaPrice');
                const statsUps = getStatsByType('D11', 'ttUpsPrice');
                const statsUpsEco = getStatsByType('D17', 'ttUpsEcoPrice');
                const statsKPack = getStatsByType('D13', 'ttKPackPrice');
                const statsSAir = getStatsByType('D14', 'ttAirSPrice');

                // 우체국 총매출(EMS 지출일지용) 최종계산
                setPostOfficeTotalSales(tempPostOfficeSales);

                // ✅ State 일괄 업데이트 (수익 & 건수)
                // 해외배송료(PT1) 데이터마다 함수에 태워서 item(pt1).shipInfoDTO.shipPrice - item(pt1).tt${각배송사컬럼명}Price 차액값을 Profit 수익상태값에 합산
                setDomeProfit(statsDome.profit);      setDomeCount(statsDome.count);
                setFedexProfit(statsFedex.profit);    setFedexCount(statsFedex.count);
                setFedexEcoProfit(statsFedexEco.profit); setFedexEcoCount(statsFedexEco.count);
                setEmsProfit(statsEms.profit);        setEmsCount(statsEms.count);
                setEmsPreProfit(statsEmsPre.profit);  setEmsPreCount(statsEmsPre.count);
                setSeaProfit(statsSea.profit);        setSeaCount(statsSea.count);
                setUpsProfit(statsUps.profit);        setUpsCount(statsUps.count);
                setUpsEcoProfit(statsUpsEco.profit);  setUpsEcoCount(statsUpsEco.count);
                setKPackProfit(statsKPack.profit);    setKPackCount(statsKPack.count);
                setSAirProfit(statsSAir.profit);      setSAirCount(statsSAir.count);

                // ✅ PT1 배송수익 총합계
                const sumDeliveryFee = statsDome.profit + statsFedex.profit + statsFedexEco.profit +
                    statsEms.profit + statsEmsPre.profit + statsSea.profit +
                    statsUps.profit + statsUpsEco.profit + statsKPack.profit + statsSAir.profit;

                setTotalDeliveryFee(sumDeliveryFee);

                // ✅ PT2 수수료 총합 계산
                const sumEtcFee = pt2Items.reduce((acc, cur) => acc + (cur.ttEtcFee || 0), 0);
                setTotalEtcFee(sumEtcFee);

                const manualVat = Number(orderVatProfit) || 0;
                const manualSale = Number(orderSaleProfit) || 0;
                const manualTransfer = Number(transferProfit) || 0;
                const manualCashbag = Number(cardCashbag) || 0;

                // 총금액 계산 = 배송대행수수료 + 기타수수료 + 구매일지 상품부가세 + 구매일지할인 + 구매일지 이체대행수수료 + 구매일지 카드캐시백
                const finalAmount = sumDeliveryFee + sumEtcFee + manualVat + manualSale + manualTransfer + manualCashbag;
                setFinalTotalAmount(finalAmount);

            })
            .catch((error) => {
                console.log("수익계산 데이터조회 오류", error);
            })
            .finally(() => {
                setIsBtLoading(false);
                setBtDisabled(false);
            });
    };






    return (
        <div className="AdminEmployeeInfoPg font-t-cont">
            <div className="admin-work-title">
                <img className="wd-35 ht-35" alt="" src={maCateImg}/>
                <p className="p-t-6">수익계산</p>
            </div>

            <div className="admin-wrap">
                <div className="admin-wrap-card full-transfer-card2 wd-30pc">

                    {/* 날짜 */}
                    <div>
                        <AdminYmdEvent startDate={startDate} endDate={endDate} startHandle={startHandle}
                                       endHandle={endHandle}/>
                    </div>

                    {/* FedEx */}
                    <div className="display-flex align-center justify-content-between font-s-12 mt-3">
                        <div className="user-center">
                            <p>FedEx</p>
                            <p style={{marginLeft:"2px"}}>(</p>
                            <p style={{color: fedexCount > 0 ? "#6499E1" : undefined, fontWeight: fedexCount > 0 ? "bold" : undefined}}>
                                {fedexCount}
                            </p>
                            <p>)</p>
                        </div>
                        <div className="user-center">
                            <p className="m-r-5">{fedexProfit.toLocaleString()}</p>원
                        </div>
                    </div>

                    {/* FedEx-E */}
                    <div className="display-flex align-center justify-content-between font-s-12 mt-2">
                        <div className="user-center">
                            <p>FedEx-E</p>
                            <p style={{marginLeft:"2px"}}>(</p>
                            <p style={{color: fedexEcoCount > 0 ? "#6499E1" : undefined, fontWeight: fedexEcoCount > 0 ? "bold" : undefined}}>
                                {fedexEcoCount}
                            </p>
                            <p>)</p>
                        </div>
                        <div className="user-center">
                            <p className="m-r-5">{fedexEcoProfit.toLocaleString()}</p>원
                        </div>
                    </div>

                    {/* UPS */}
                    <div className="display-flex align-center justify-content-between font-s-12 mt-2">
                        <div className="user-center">
                            <p>UPS</p>
                            <p style={{marginLeft:"2px"}}>(</p>
                            <p style={{color: upsCount > 0 ? "#6499E1" : undefined, fontWeight: upsCount > 0 ? "bold" : undefined}}>
                                {upsCount}
                            </p>
                            <p>)</p>
                        </div>
                        <div className="user-center">
                            <p className="m-r-5">{upsProfit.toLocaleString()}</p>원
                        </div>
                    </div>

                    {/* UPS-E */}
                    <div className="display-flex align-center justify-content-between font-s-12 mt-2">
                        <div className="user-center">
                            <p>UPS-E</p>
                            <p style={{marginLeft:"2px"}}>(</p>
                            <p style={{color: upsEcoCount > 0 ? "#6499E1" : undefined, fontWeight: upsEcoCount > 0 ? "bold" : undefined}}>
                                {upsEcoCount}
                            </p>
                            <p>)</p>
                        </div>
                        <div className="user-center">
                            <p className="m-r-5">{upsEcoProfit.toLocaleString()}</p>원
                        </div>
                    </div>

                    {/* 우체국(EMS, EMSP, K-Packet) 지출일지용 총매출 */}
                    <div className="display-flex align-center justify-content-between font-s-12 mt-2">
                        <div className="user-center">
                            <p>우체국총매출(지출일지용)</p>
                        </div>
                        <div className="user-center">
                            <p className="m-r-5">{postOfficeTotalSales.toLocaleString()}</p>원
                        </div>
                    </div>

                    {/* EMS */}
                    <div className="display-flex align-center justify-content-between font-s-12 mt-2">
                        <div className="user-center">
                            <p>EMS</p>
                            <p style={{marginLeft:"2px"}}>(</p>
                            <p style={{color: emsCount > 0 ? "#6499E1" : undefined, fontWeight: emsCount > 0 ? "bold" : undefined}}>
                                {emsCount}
                            </p>
                            <p>)</p>
                        </div>
                        <div className="user-center">
                            <p className="m-r-5">{emsProfit.toLocaleString()}</p>원
                        </div>
                    </div>

                    {/* EMS-P */}
                    <div className="display-flex align-center justify-content-between font-s-12 mt-2">
                        <div className="user-center">
                            <p>EMS-P</p>
                            <p style={{marginLeft:"2px"}}>(</p>
                            <p style={{color: emsPreCount > 0 ? "#6499E1" : undefined, fontWeight: emsPreCount > 0 ? "bold" : undefined}}>
                                {emsPreCount}
                            </p>
                            <p>)</p>
                        </div>
                        <div className="user-center">
                            <p className="m-r-5">{emsPreProfit.toLocaleString()}</p>원
                        </div>
                    </div>

                    {/* K-Packet */}
                    <div className="display-flex align-center justify-content-between font-s-12 mt-2">
                        <div className="user-center">
                            <p>K-Packet</p>
                            <p style={{marginLeft:"2px"}}>(</p>
                            <p style={{color: kPackCount > 0 ? "#6499E1" : undefined, fontWeight: kPackCount > 0 ? "bold" : undefined}}>
                                {kPackCount}
                            </p>
                            <p>)</p>
                        </div>
                        <div className="user-center">
                            <p className="m-r-5">{kPackProfit.toLocaleString()}</p>원
                        </div>
                    </div>

                    {/* S-Air */}
                    <div className="display-flex align-center justify-content-between font-s-12 mt-2">
                        <div className="user-center">
                            <p>S-Air</p>
                            <p style={{marginLeft:"2px"}}>(</p>
                            <p style={{color: sAirCount > 0 ? "#6499E1" : undefined, fontWeight: sAirCount > 0 ? "bold" : undefined}}>
                                {sAirCount}
                            </p>
                            <p>)</p>
                        </div>
                        <div className="user-center">
                            <p className="m-r-5">{sAirProfit.toLocaleString()}</p>원
                        </div>
                    </div>

                    {/* Sea */}
                    <div className="display-flex align-center justify-content-between font-s-12 mt-2">
                        <div className="user-center">
                            <p>Sea</p>
                            <p style={{marginLeft:"2px"}}>(</p>
                            <p style={{color: seaCount > 0 ? "#6499E1" : undefined, fontWeight: seaCount > 0 ? "bold" : undefined}}>
                                {seaCount}
                            </p>
                            <p>)</p>
                        </div>
                        <div className="user-center">
                            <p className="m-r-5">{seaProfit.toLocaleString()}</p>원
                        </div>
                    </div>

                    <div className="display-flex align-center justify-content-between font-s-12 mt-2">
                        <div className="user-center">
                            <p>국내배송</p>
                            <p style={{marginLeft:"2px"}}>(</p>
                            <p style={{color: domeCount > 0 ? "#6499E1" : undefined, fontWeight: domeCount > 0 ? "bold" : undefined}}>{domeCount}</p>
                            <p>)</p>
                        </div>
                        <div className="user-center">
                            <p className="m-r-5">{domeProfit.toLocaleString()}</p>원
                        </div>
                    </div>

                    {/*구분선*/}
                    <div style={{
                        borderBottom: "1px solid #EAEAEA",
                        width: "100%",
                        marginTop:"15px"
                    }}></div>

                    <div className="display-flex align-center justify-content-between font-s-12 mt-3">
                        <p>총배송수수료</p>
                        <div className="user-center">
                            <p className="m-r-5">{totalDeliveryFee.toLocaleString()}</p>원
                        </div>
                    </div>

                    <div className="display-flex align-center justify-content-between font-s-12 mt-2">
                        <p>총기타수수료</p>
                        <div className="user-center">
                            <p className="m-r-5">{totalEtcFee.toLocaleString()}</p>원
                        </div>
                    </div>

                    <div className="user-input-container wd-100pc ht-40 border-rd4" style={{marginTop: "20px"}}>
                        <input type="text" onChange={(e) => handleOrderVatProfit(e)}
                               value={orderVatProfit} maxLength={12} placeholder="구매일지 부가세수익"
                               className="ReviewInput user-input wd-100pc p-l-10 p-r-10" style={{fontSize: "12px"}}
                        />
                    </div>

                    <div className="user-input-container wd-100pc ht-40 border-rd4" style={{marginTop: "10px"}}>
                        <input type="text" onChange={(e) => handleOrderSaleProfit(e)}
                               value={orderSaleProfit} maxLength={12} placeholder="구매일지 할인수익"
                               className="ReviewInput user-input wd-100pc p-l-10 p-r-10" style={{fontSize: "12px"}}
                        />
                    </div>

                    <div className="user-input-container wd-100pc ht-40 border-rd4" style={{marginTop: "10px"}}>
                        <input type="text" onChange={(e) => handleTransferProfit(e)}
                               value={transferProfit} maxLength={12} placeholder="환전수익"
                               className="ReviewInput user-input wd-100pc p-l-10 p-r-10" style={{fontSize: "12px"}}
                        />
                    </div>

                    <div className="user-input-container wd-100pc ht-40 border-rd4" style={{marginTop: "10px"}}>
                        <input type="text" onChange={(e) => handleCardCashbagProfit(e)}
                               value={cardCashbag} maxLength={12} placeholder="카드 캐시백수익"
                               className="ReviewInput user-input wd-100pc p-l-10 p-r-10" style={{fontSize: "12px"}}
                        />
                    </div>

                    <div className="display-flex align-center justify-content-between font-s-14 mt-3">
                        <p>총 금액 : </p>
                        <div className="user-center">
                            <p className="m-r-5"
                               style={{color: finalTotalAmount > 0 ? "darkorange" : "black"}}>{finalTotalAmount.toLocaleString()}</p>원
                        </div>
                    </div>

                    {/*<div className="user-center mt-4">*/}
                    {/*    <style>*/}
                    {/*        {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}*/}
                    {/*    </style>*/}

                    {/*    <button className="bt-btn-B wd-100 ht-35 btn-click-event font-s-13" disabled={btDisabled}>*/}
                    {/*        {isBtLoading ? (*/}
                    {/*            <div className="orangeSpinner"></div>*/}
                    {/*        ) : (*/}
                    {/*            "계산"*/}
                    {/*        )}*/}
                    {/*    </button>*/}
                    {/*</div>*/}

                </div>
            </div>
        </div>
    );
}

export default AdminProfitCalcuPg
